import { Fullscreen } from "lucide-react";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { ViewerContext } from "../../Context/ViewerContext/ViewerContextProvider";
import { XktContext } from "../../Context/XktContext/XktContextProvider";
import useFlyTo from "../../Hooks/FlyTo/FlyTo";
import { Toggle } from "../ui/toggle";
import { Tooltip, TooltipContent, TooltipTrigger } from "../ui/tooltip";

const ZoomToFit = () => {
    const { state } = useContext(XktContext);
    const { state: viewerState } = useContext(ViewerContext);
    const { flyTo } = useFlyTo();
    const { t } = useTranslation();
    const zoomToFit = () => {
        if (state.viewer == null) return;
        let aabb: number[] = [];
        if (viewerState.selectedEntities.length !== 0) {
            flyTo(viewerState.selectedEntities as string[]);
        } else {
            let elements: string[] = [];
            for (const m of Object.keys(state.viewer.scene.models)) {
                const model = state.viewer.scene.models[m];
                elements = [...elements, ...state.viewer.scene.objectIds.filter((x) => x.includes(model.id as string))];
                if (model.visible) {
                    if (aabb.length == 0) {
                        aabb = model.aabb;
                    } else {
                        if (aabb[0] > model.aabb[0]) aabb[0] = model.aabb[0];
                        if (aabb[1] > model.aabb[1]) aabb[1] = model.aabb[1];
                        if (aabb[2] > model.aabb[2]) aabb[2] = model.aabb[2];
                        if (aabb[3] < model.aabb[3]) aabb[3] = model.aabb[3];
                        if (aabb[4] < model.aabb[4]) aabb[4] = model.aabb[4];
                        if (aabb[5] < model.aabb[5]) aabb[5] = model.aabb[5];
                    }
                }
            }
            flyTo(elements, aabb);
        }
    };
    return (
        <Tooltip>
            <TooltipTrigger asChild>
                <span className="inline-flex">
                    <Toggle
                        value="strikethrough"
                        aria-label={t("toggleZoomToFit")}
                        className="ml-1"
                        pressed={false}
                        onClick={zoomToFit}
                    >
                        <Fullscreen className="h-4 w-4" />
                    </Toggle>
                </span>
            </TooltipTrigger>
            <TooltipContent>
                <p>{t("zoomToFit")}</p>
            </TooltipContent>
        </Tooltip>
    );
};

export default ZoomToFit;
